import { render } from "./AddressForm.vue?vue&type=template&id=8c64b0e6&scoped=true&ts=true"
import script from "./AddressForm.vue?vue&type=script&lang=ts"
export * from "./AddressForm.vue?vue&type=script&lang=ts"

import "./AddressForm.vue?vue&type=style&index=0&id=8c64b0e6&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c64b0e6"]])

export default __exports__